// @moods/ui copy for forum posts, search highlights and the voice-message recorder. tr and en must have identical keys.
// Turkish part; discussions.en.ts must have the same keys.
const dict: Record<string, string> = {
  'discussions.forum.locked': 'Kilitli',
  'discussions.forum.archived': 'Arşivlendi',
  'discussions.forum.replies': '{count} yanıt',
  'discussions.forum.reactions': '{count} tepki',
  'discussions.forum.following': 'Takip ediyorsun',
  'discussions.voice.recording': 'Sesli mesaj kaydediliyor',
  'discussions.voice.timer': '{elapsed} / {max}',
  'discussions.voice.holdHint': 'İptal için sola kaydır ya da Esc',
  'discussions.voice.releaseToCancel': 'İptal etmek için bırak',
  'discussions.voice.sending': 'Gönderiliyor…',
  'discussions.voice.cancel': 'Kaydı iptal et',
  'discussions.voice.send': 'Sesli mesajı gönder',
};

export default dict;
